import React from "react";
import Particles from "particlesjs";
import "./About.css";
import aboutImg from "../../assets/mepro.jpg";
import CV from "../../assets/cvnew.pdf";
import Info from "../Info/Info";

const About = () => {
  window.onload = function () {
    Particles.init({
      selector: ".background",
      maxParticles: 50,
      sizeVariations: 2,
      minDistance: 120,
      connectParticles: true,
    });
  };

  return (
    <section className="about section" id="about">
      <h2 className="section_title about section">About Me</h2>
      <span className="section_subtitle">My Background</span>

      <div className="about_container container grid">
        <div className="about_img-container">
          <img src={aboutImg} alt="aboutImage" className="about_img" />
        </div>

        <div className="about_data">
          <Info />
          <p className="about_description">
            Hi, I am a certified software engineer, proficient in developing
            software, web applications, and more.
          </p>
          <a download="" href={CV} className="btn btn-primary">
            Download Resume
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
